import Vue from 'vue'
import Vuex from 'vuex'
import auth from "./auth";
import cart from "./cart";
import unitCodes from "./unitCodes";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const getDefaultFilters = () => ({
  show: true,

  orders: {
    search: null,
    selectedOrderStatus: "all",
    startDate: null,
    endDate: null,
  },

  dashboard: {
    selectedType: [],
    showInactive: false,
  },

  pool: {
    firmType: "supplier",
  },

  restaurant: {
    products: {
      selectedRelatedSupplier: null,
      selectedWarehouse: null,
      selectedMenu: null,
      selectedProductGroup: null,
      selectedOrderableFilter: null,
      selectedCookStationFilter: null,
      selectedTaxFilter: null,
      productType: null,
      search: null,
    },
    supplierOrders: {
      selectedSupplier: null,
      selectedProductGroup: null,
      selectedWarehouse: null,
      selectedOrderDepartment: null,
      search: null,
      columnsPerRow: 3,
    },
  },

  pgroupAssign: {
    selectedProductGroup: null,
    selectedSupplier: null,
    productSearch: null,
    showRestaurantSuppliedOnly: false,
  },
});

const state = {
  // sidebarShow: 'responsive',
  sidebarShow: false,
  sidebarMinimize: true,
  asideShow: false,
  darkMode: false,

  // For Filter
  filters: getDefaultFilters(),

  // Product Asides
  asideAddToWarehouse: false,
  asideProductQuickEditId: null,
  asideProductQuickEditTab: 'edit',
  viewProductModalId: null,
  productSuppliersModalId: null,
  productEditModalId: null,
  productEditModalMenuId: null, // Pre-selected menu when creating from menu products

  // Restaurant Supplier Orders
  customizeProductModal: false,
  emailPreviewModal: false,
  shoppingCartSidebar: false,
  firmAddressesModal: false,
  extraItemModal: false,
  pgroupModal: false,
  pgroupAssignModal: false,
  warehouseModal: false,
  warehousePriorityModal: false,
  warehouseCentralModal: false,
  warehouseProductSortModal: false,
  warehouseProductModal: false,

  // Supplier order receiving check display preference
  supplierOrderCheckItemSort: {
    key: 'name',
    direction: 'asc',
  },

  // MC
  selectedFirm: null,

  // * Auth
  errors: [],
};

const mutations = {
  setSelectedFirm(state, firm) {
    const currentFirmId = state.selectedFirm?.id ?? null;
    const nextFirmId = firm?.id ?? null;

    if (currentFirmId !== nextFirmId) {
      state.filters = getDefaultFilters();
    }

    state.selectedFirm = firm;
  },

  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state, [variable, value]) {
    state[variable] = value
  },
  setSupplierOrderCheckItemSort(state, sort) {
    const key = ['name', 'supplier_product_number'].includes(sort?.key)
      ? sort.key
      : 'name';
    const direction = sort?.direction === 'desc' ? 'desc' : 'asc';

    state.supplierOrderCheckItemSort = { key, direction };
  },
  toggle(state, variable) {
    state[variable] = !state[variable]
  },

  // * Auth
  setErrors(state, errors) {
    state.errors = errors;
  }
}

// * Auth
const getters = {
  errors: state => state.errors
}

const plugins = [
  createPersistedState({
    paths: ['selectedFirm', 'auth', 'filters.pgroupAssign', 'supplierOrderCheckItemSort']
  })
];

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions: {},
  modules: {
    auth,
    cart,
    unitCodes,
  },
  plugins
})
